const initialState = {}

const sideBar = (state = initialState, {type, payload}) => {
  const directMessagesAttributes = (state, payload) => {
    const attributes = {directMessagesUnseen: payload}
    if (payload - state.directMessagesUnseen != 1) return attributes

    return {...attributes, directUnseenIncreased: new Boolean(true)}
  }

  const groupMessagesAttributes = (state, payload) => { 
    const attributes = {groupMessagesUnseen: payload}
    if (payload - state.groupMessagesUnseen < 1) return attributes

    return {...attributes, groupUnseenIncreased: new Boolean(true)}
  }

  switch (type) {
    case 'SIDE_BAR.INIT':
      return {...state, ...payload,
        directMessagesUnseen: state.directMessagesUnseen || 0,
        groupMessagesUnseen: state.groupMessagesUnseen || 0,
        directUnseenIncreased: false, groupUnseenIncreased: false}
    case 'SIDE_BAR.DIRECT_MESSAGES_UNSEEN':
      return {...state, ...directMessagesAttributes(state, payload)}
    case 'SIDE_BAR.GROUP_MESSAGES_UNSEEN':
      return {...state, ...groupMessagesAttributes(state, payload)}
    default:
      return state
  }
}

export default sideBar
